import './data-card.scss';
import  {IDataCardIndicator} from "./data-card-indicators/data-card-order-out-of-policy-indicator";
import DataCardToolBar, {IDataCardToolbarProps} from "./data-card-toolbar/data-card-toolbar";


interface Props {
	children: React.ReactNode,
	toolbar?: IDataCardToolbarProps
    hasTopIndicator?: boolean,
    TopIndicator?: React.FC<IDataCardIndicator>
}

const DataCard: React.FC<Props> = ({
	toolbar,
	children,
    hasTopIndicator,
    TopIndicator
}) => {

 

	return (
        <div className={`data-card-wrapper`}>
            { hasTopIndicator &&
                <div className={'data-card-indicator-wrapper'}>
                    {TopIndicator ? <TopIndicator/> : ''}
                </div>
            }
            <div className='data-card'>
                { toolbar &&
                    <DataCardToolBar {...toolbar}></DataCardToolBar>
                }
                <div className='data-card-content'>
                    {children}
                </div>
            </div>
        </div>
	);
}

export default DataCard;